import { type Static, type TSchema, Type } from "@sinclair/typebox"

// Helpers y schemas transversales — convenciones de docs/04 §1.
// ProblemDetails (RFC 7807) ya existe en ../error-codes.

export const Nullable = <T extends TSchema>(schema: T) => Type.Union([schema, Type.Null()])

export const IsoDateTimeSchema = Type.String({ format: "date-time" })

// Objetos jsonb libres (profile, meta, data…)
export const JsonRecordSchema = Type.Record(Type.String(), Type.Unknown())
export type JsonRecord = Static<typeof JsonRecordSchema>

// Paginación por cursor: ?limit=50&cursor=…
export const CursorQuerySchema = Type.Object({
  limit: Type.Optional(Type.Integer({ minimum: 1, maximum: 100, default: 50 })),
  cursor: Type.Optional(Type.String()),
})
export type CursorQuery = Static<typeof CursorQuerySchema>

// Página de resultados: { "data": [...], "next_cursor": "…" | null }
export const createPageSchema = <T extends TSchema>(item: T) =>
  Type.Object({
    data: Type.Array(item),
    next_cursor: Nullable(Type.String()),
  })

export interface Page<T> {
  data: T[]
  next_cursor: string | null
}

// Confirmación para acciones sin payload de respuesta (heartbeat, cierres, etc.)
export const OkResponseSchema = Type.Object({ ok: Type.Literal(true) })
export type OkResponse = Static<typeof OkResponseSchema>

export const NODE_STATUSES = ["active", "draining", "down", "disabled"] as const
export type NodeStatus = (typeof NODE_STATUSES)[number]

export const NodeStatusSchema = Type.Union([
  Type.Literal("active"),
  Type.Literal("draining"),
  Type.Literal("down"),
  Type.Literal("disabled"),
])

// Shard tal como viaja en login/userinfo y shard/resolve — docs/04 §2.
export const ShardInfoSchema = Type.Object({
  id: Type.String(),
  name: Type.String(),
  url: Type.String(),
  status: NodeStatusSchema,
})
export type ShardInfo = Static<typeof ShardInfoSchema>
